import { compose } from 'recompose';
import apiInterceptor from '../../../api/interceptor';
import NewPurchaseVatReport from './NewPurchaseVatReport';
import { newPurchaseVatApi } from '../../common/base.api';

const composedNewPurchaseVatReport = compose(apiInterceptor({ ...newPurchaseVatApi }))(NewPurchaseVatReport);

export default composedNewPurchaseVatReport;
